import { IconSvg, IconSvgProps } from "./icon"

export default function Baggage(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M7.62 7.74H5.81c-1 0-1.81.81-1.81 1.81v8.276c0 1 .81 1.81 1.81 1.81h11.38c1 0 1.81-.81 1.81-1.81V9.55c0-1-.81-1.81-1.81-1.81H11.5z" />
      <path
        d="M7.62 7.74V6.447a1.81 1.81 0 0 1 1.811-1.81h4.138a1.81 1.81 0 0 1 1.81 1.81V7.74m-7.758 0H5.81c-1 0-1.81.81-1.81 1.81v8.276c0 1 .81 1.81 1.81 1.81H17.19c1 0 1.81-.81 1.81-1.81V9.55c0-1-.81-1.81-1.81-1.81h-1.81m-7.76 0h7.76"
        fill="none"
      />
    </IconSvg>
  )
}
